<template>
  <div class="news-box">
    <img
      class="img-bj"
      src="@/assets/img/images/news-bj.png"
      alt="news-bj.png"
    />
    <div class="info-box">
      <p class="title1">{{ $t("news.title") }}</p>
      <p class="title2">{{ $t("news.titleInfo") }}</p>
      <div class="type-box">
        <!-- <div
          :class="{ sel: pageParams.cateCode === 'system_notice' }"
          @click="typeChange('system_notice')"
        >
          {{ $t("news.tabVal1") }}
        </div> -->
        <div
          :class="{ sel: pageParams.cateCode === 'platform_notice' }"
          @click="typeChange('platform_notice')"
        >
          {{ $t("news.tabVal2") }}
        </div>
        <div
          :class="{ sel: pageParams.cateCode === 'news' }"
          @click="typeChange('news')"
        >
          {{ $t("news.tabVal3") }}
        </div>
      </div>
      <div class="news-list-box">
        <NewsNoData v-if="newsList.length <= 0" />
        <template v-for="(item, index) in newsList" v-else>
          <NewsItem :item="item" />
        </template>
      </div>

      <el-pagination
        v-if="pageTotal > 0"
        class="pagination-box"
        background
        layout="prev, pager, next"
        :total="pageTotal"
        :page-size="12"
        :current-page="pageParams.page"
        @current-change="pageChange"
      />
    </div>
    <VFooter />
    <QuestionPopup />
  </div>
</template>

<script>
import { mapState } from "vuex";
import NewsItem from "./components/NewsItem";
import NewsNoData from "./components/NewsNoData";
import VFooter from "@/components/footer/VFooter";
import QuestionPopup from "@/components/QuestionPopup/index";
export default {
  components: {
    VFooter,
    NewsItem,
    NewsNoData,
    QuestionPopup,
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  data() {
    return {
      pageTotal: 0,
      newsList: [],
      pageParams: {
        page: 1,
        rows: 12,
        cateCode: "platform_notice", // 焦点图：banner、新闻：news、系统通知：system_notice，平台公告：platform_notice、个人消息：personal_notice、常见问题：question
      },
    };
  },
  created() {
    this.getNewsList();
  },
  methods: {
    pageChange(val) {
      this.pageParams.page = val;
      this.getNewsList();
    },
    typeChange(val) {
      this.pageParams.page = 1;
      this.pageParams.cateCode = val;
      this.getNewsList();
    },
    getNewsList() {
      const _this = this;
      this.$axios.post("/cms/getList", _this.pageParams).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          _this.newsList = res.data.data.rows || [];
          _this.pageTotal = res.data.data.total || 0;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.news-box {
  position: relative;
  background: #f5f6f7;
  .img-bj {
    top: 0;
    left: 0;
    width: 100%;
    height: 763px;
    z-index: 1;
    position: absolute;
  }
  .info-box {
    z-index: 2;
    position: relative;
    .news-list-box {
      margin-top: 28px;
      display: flex;
      gap: 28px;
      flex-wrap: wrap;
      padding: 0 260px;
      justify-content: center;
    }
    .title1 {
      padding-top: 120px;
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 36px;
      color: #333333;
    }
    .title2 {
      padding-top: 20px;
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #666666;
    }
    .type-box {
      gap: 20px;
      display: flex;
      margin-top: 20px;
      justify-content: center;
      div {
        // width: 104px;
        height: 40px;
        cursor: pointer;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #4063ff;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #4063ff;
        text-align: center;
        line-height: 40px;
		padding: 0 10px;
      }
      .sel {
        color: #ffffff;
        background: #4063ff;
      }
    }
    .pagination-box {
      text-align: center;
      margin-top: 60px;
      margin-bottom: 120px;
      /deep/ .btn-prev,
      /deep/ .btn-next,
      /deep/ .number {
        width: 44px;
        height: 44px;
        line-height: 44px;
        background: #ffffff;
        box-shadow: 0px 3px 10px 1px rgba(180, 180, 180, 0.06);
        border-radius: 6px 6px 6px 6px;
      }
      /deep/ .active {
        background-color: #4063ff !important;
      }
    }
  }
}
</style>
